export default "__VITE_ASSET__DaGA_jCv__"